import { createSlice } from '@reduxjs/toolkit';
import {
  postIntroduction,
  fetchIdentifications,
  submitIdentifications,
  deliverOtp,
  verifyOtp,
  confirmAccount,
} from './thunk';

import { RegistrationState } from './types';

const initialState: RegistrationState = {
  session_id: null,
  identifications: [],
  userDetails: null,
  otpStatus: null,
  confirmationStatus: null,
  status: 'idle',
  error: null,
};

const registrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    resetRegistration: () => initialState,
  },
  extraReducers: (builder) => {
    builder

      .addCase(postIntroduction.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(postIntroduction.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.session_id = action.payload.session_id;
      })
      .addCase(postIntroduction.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Failed to initiate registration';
      })

      .addCase(fetchIdentifications.fulfilled, (state, action) => {
        state.identifications = action.payload;
      })

      .addCase(submitIdentifications.fulfilled, (state, action) => {
        state.userDetails = action.payload;
      })

      .addCase(deliverOtp.pending, (state) => {
        state.otpStatus = 'loading';
      })
      .addCase(deliverOtp.fulfilled, (state, action) => {
        state.otpStatus = 'succeeded';
      })
      .addCase(deliverOtp.rejected, (state, action) => {
        state.otpStatus = 'failed';
        state.error = action.error.message || 'OTP delivery failed';
      })

      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.status = 'otp_verified';
      })

      .addCase(confirmAccount.pending, (state) => {
        state.confirmationStatus = 'loading';
      })
      .addCase(confirmAccount.fulfilled, (state, action) => {
        state.confirmationStatus = 'succeeded';
        state.userDetails = action.payload;
      })
      .addCase(confirmAccount.rejected, (state, action) => {
        state.confirmationStatus = 'failed';
        state.error = action.error.message || 'Account confirmation failed';
      });
  },
});

export const { resetRegistration } = registrationSlice.actions;
export default registrationSlice.reducer;
